const stats = [
  {
    value: "1M+",
    label: "Membres actifs sur LinkedIn",
  },
  {
    value: "80%",
    label: "des décideurs B2B utilisent LinkedIn",
  },
  {
    value: "70%",
    label: "des prospects font confiance aux contenus experts",
  },
];

const StatsSection = () => {
  return (
    <section className="relative z-10 overflow-hidden bg-blue-600 py-24">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-y-10">
          {stats.map((item, index) => (
            <div
              key={index}
              className="w-full px-4 text-center md:w-1/2 lg:w-1/3"
            >
              <div className="mx-auto max-w-[325px]">
                <h3 className="mb-4 text-4xl font-bold text-white lg:text-5xl">
                  {item.value}
                </h3>
                <p className="text-base text-white sm:text-lg">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Décor optionnel (shape de fond) */}
      <div className="absolute left-1/2 top-0 -z-10 h-full w-full -translate-x-1/2">
        {/* Remplace ce SVG si tu veux */}
        <div className="h-full w-full bg-gradient-to-r from-blue-700/50 to-blue-800/30 opacity-20"></div>
      </div>
    </section>
  );
};

export default StatsSection;
